import React from 'react';

export default ({active = true}) => {
    const iconColor = active ? "black" : "#DFDFDF";

return	(
        <svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="11.8354" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="13.9238" width="11.8354" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect y="5.57031" width="11.8354" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="13.9238" y="5.57031" width="11.8354" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect y="11.1406" width="11.8354" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="13.9238" y="11.1406" width="11.8354" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect y="16.707" width="11.8354" height="3.48101" rx="1.74051" fill={iconColor}/>
            <rect x="13.9238" y="16.707" width="11.8354" height="3.48101" rx="1.74051" fill={iconColor}/>
        </svg>
	)
}